import { useContext, useMemo } from "react";
import { useRowChatDrag } from "@components/tasks/chatDrag/useRowChatDrag";
import { useAddCounterpartiesToChat } from "@components/tasks/useAddReferencesToChat";
import { DirectoryContext } from "./Directory.context";
import { CounterpartyDirectoryViewRow } from "./counterpartyDirectoryViewTypes";

const toChatItem = (row: CounterpartyDirectoryViewRow) =>
    row.isAccountRow || row.isNoCounterparty
        ? null
        : (row.counterparty ?? null);

/** `rowDragOut` for the counterparty directory: drags counterparties into the task chat. */
export function useDirectoryRowChatDrag(rows: CounterpartyDirectoryViewRow[]) {
    const { rowSelection, clearRowSelection } = useContext(DirectoryContext);
    const selectedCounterparties = useMemo(
        () =>
            rows.flatMap((row) => {
                const counterparty = toChatItem(row);
                return rowSelection[row.id] && counterparty
                    ? [counterparty]
                    : [];
            }),
        [rows, rowSelection],
    );
    const { canAddToChat, addCounterpartiesToChat } =
        useAddCounterpartiesToChat();
    return useRowChatDrag({
        noun: "counterparty",
        canAddToChat,
        getRowItem: toChatItem,
        selectedItems: selectedCounterparties,
        addToChat: addCounterpartiesToChat,
        clearSelection: clearRowSelection,
    });
}
